import React from 'react'
import styled from 'styled-components'

import { CustomButton } from '../common/style/button'

export const NavigationButton = styled(CustomButton)`
  &:disabled {
    opacity: 0.5;
  }
`

export const Left: React.FC = props => (
  <svg
    width="50px"
    height="50px"
    viewBox="0 0 50 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect fill="#FFFFFF" x="0" y="0" width="50" height="50" rx="25" />
      <path
        d="M28.640625,18.140625 C28.7447922,18.2447922 28.796875,18.3645827 28.796875,18.5 C28.796875,18.6354173 28.7447922,18.7552078 28.640625,18.859375 L22.5,25 L28.640625,31.140625 C28.7447922,31.2447922 28.796875,31.3645827 28.796875,31.5 C28.796875,31.6354173 28.7447922,31.7552078 28.640625,31.859375 L27.859375,32.640625 C27.7552078,32.7447922 27.6354173,32.796875 27.5,32.796875 C27.3645827,32.796875 27.2447922,32.7447922 27.140625,32.640625 L19.859375,25.359375 C19.7552078,25.2552078 19.703125,25.1354173 19.703125,25 C19.703125,24.8645827 19.7552078,24.7447922 19.859375,24.640625 L27.140625,17.359375 C27.2447922,17.2552078 27.3645827,17.203125 27.5,17.203125 C27.6354173,17.203125 27.7552078,17.2552078 27.859375,17.359375 L28.640625,18.140625 Z"
        stroke="#82B2FF"
        fill="#82B2FF"
      />
    </g>
  </svg>
)

export const Right = styled(Left)`
  transform: scaleX(-1);
`

export const Dots: React.FC<{ count: number; activeIndex: number }> = ({
  count,
  activeIndex,
}) => {
  return (
    <Wrapper>
      {new Array(count).fill(1).map((_, index) => (
        <Dot active={index === activeIndex} key={index} />
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
`

const Dot = styled.div<{ active: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  margin: 3.5px;
  background-color: ${props => (props.active ? '#0073c0' : '#ffffff')};
  opacity: 0.5;
`
